/**
 * Centralized API Configuration
 *
 * Change the base URL here to switch between environments:
 * - Development: http://localhost:5010
 * - Production: https://api.codetrend.mx
 */

// Change this URL to switch environments
//const API_BASE_URL = 'http://localhost:5010';
const API_BASE_URL = 'https://api.codetrend.com/tradelab'; // Production

export const config = {
  /**
   * Base URL for REST API endpoints (includes /api path)
   * Used by: axios instance in services/api.ts
   */
  apiBaseUrl: `${API_BASE_URL}/api`,

  /**
   * Base URL for Server-Sent Events (no /api path)
   * Used by: EventSource connections in services/sseService.ts
   */
  sseBaseUrl: API_BASE_URL,

  /**
   * Raw base URL without paths
   */
  baseUrl: API_BASE_URL,
};
